export type ProfileTab = 'overview' | 'academics' | 'fees' | 'letters' | 'timeline';

export const PROFILE_TABS: Array<{ key: ProfileTab; label: string }> = [
  { key: 'overview',  label: 'Overview' },
  { key: 'academics', label: 'Academics' },
  { key: 'fees',      label: 'Fees' },
  { key: 'letters',   label: 'Letters' },
  { key: 'timeline',  label: 'Timeline' },
];

/** Older links (?tab=admissions / enrollments) land on Academics. */
export const profileTabFrom = (raw: string | null): ProfileTab => {
  if (raw === 'admissions' || raw === 'enrollments') return 'academics';
  return PROFILE_TABS.some(t => t.key === raw) ? (raw as ProfileTab) : 'overview';
};
